import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/estructura-organizacional/autorizacion-contratacion-detalle/';

/**
 * GET Autorizaciones de Contrataciones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getAutorizacionesContratacionesDetalle = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Autorización de Contratación (Individual)
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getAutorizacionContratacionDetalle = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Autorización de Contratación
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postAutorizacionContratacionDetalle = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Autorización de Contratación
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchAutorizacionContratacionDetalle = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}/`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Autorización de Contratación
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteAutorizacionContratacionDetalle = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Autorización de Contratación
 * Cambia el estatus global a Autorizado
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarAutorizacionContratacionDetalle = async (id) => {
  try {
    const response = await API.patch(`${baseURI}${id}/`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT Autorizar Contratación Masiva
 * @param {number} idAutorizacion - ID del padre
 * @param {Array} payload - [{ id, observaciones }]
 */
export const putAutorizarContratacionMasiva = async (idAutorizacion, payload) => {
  try {
    const response = await API.put(
      '/estructura-organizacional/autorizar-contratacion',
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    onSuccess(response, 'Autorización realizada correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    throw err; // IMPORTANTE: para que llegue al catch del front
  }
};
